import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TRANGE',
  version: 1,
  label: 'True Range',
  pane: 'sub',
  category: 'volatility',
  series: 'price',
  order: 30,
  inputs: [],
  outputs: [line('trange', 'TR', COLOR.blue)],
  talib: { functions: ['TRANGE'], expr: 'TRANGE(high, low, close)' },
  listed: true,
  tailSafe: true,
  // TA-Lib ignores the first bar (no previous close) rather than using high − low.
  lookback: () => 1,
}
export default def
